/// <amd-module name="Build/Pipelines/Stores/PipelineTriggerIssuesStore" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IServerException, IVssContributionService } from "VSS/Platform/Contribution";
import { PipelineTriggerIssuesList, PipelineTriggerIssues } from "Build/Client/Contracts/DataProvider";
import * as Resources from "Build/Pipelines/Resources";
import { Store } from "Build/Flux/Store";
import { Statuses, IStatusProps } from "VSSUI/Status";

export interface ITriggerIssuesGridRow {
    statusType: IStatusProps;
    errorMessage: string;
    alias: string;
    source: string;
    yamlCommit: string;
    repositoryUrl: string;
    date: Date;
}

export interface ITriggerIssuesState {
    triggerIssueData: ITriggerIssuesGridRow[];
}

export class PipelineTriggerIssuesStore extends Store {
    constructor(context: IVssPageContext, definitionId: number) {
        super();
        this.definitionId = definitionId;
        this._pageContext = context;
        this._state = {
            triggerIssueData: []
        };
        this._initialize();
    }

    private _initialize() {
        let triggerIssuesData: ITriggerIssuesGridRow[] = [];
        this._getTriggerIssuesData().then((data: PipelineTriggerIssuesList | undefined) => {
            if (data && data.pipelineTriggerIssues) {
                data.pipelineTriggerIssues.map(triggerIssue => {
                    triggerIssue && triggerIssue.sourceVersion && !this.checkTriggerIssueExists(triggerIssue, triggerIssuesData) && triggerIssuesData.push({
                            statusType: triggerIssue.isError ? Statuses.Failed : Statuses.Warning,
                            errorMessage: triggerIssue.errorMessage,
                            alias: triggerIssue.alias,
                            source: triggerIssue.buildNumber,
                            yamlCommit: triggerIssue.sourceVersion,
                            repositoryUrl: triggerIssue.repositoryUrl,
                            date: triggerIssue.createdOn
                        });
                });
                if (triggerIssuesData.length > 0) {
                    this._state.triggerIssueData = triggerIssuesData;
                    this.emitChanged();
                }
            }
        });
    }

    private _getTriggerIssuesData = (): Promise<PipelineTriggerIssuesList> => {
        return new Promise((resolve, reject) => {
            const contributionService = this._pageContext.getService<IVssContributionService>("IVssContributionService");
            contributionService.getDataAsync<PipelineTriggerIssuesList>("ms.vss-build-web.trigger-issues-data-provider", { "pipelineDefinitionId": this.definitionId.toString() }, true)
                .then((data: PipelineTriggerIssuesList | undefined) => {
                    if (data) {
                        resolve(data);
                    }
                    else {
                        const ex: IServerException = contributionService.getDataProviderExceptions()[this.definitionId.toString()];
                        const message = (ex && ex.message) || Resources.TriggerIssuesErrorMessage;
                        reject(new Error(message));
                    }
                });
        });
    }

    private checkTriggerIssueExists = (triggerIssue: PipelineTriggerIssues, triggerIssueData: ITriggerIssuesGridRow[]): boolean => {
        var triggerIssueExists = false;
        triggerIssue.isError && triggerIssueData.map((data) => {
            if(data.statusType == Statuses.Failed && data.yamlCommit == triggerIssue.sourceVersion) {
                triggerIssueExists = true;
            }
        });
        return triggerIssueExists;
    }

    public getState(): ITriggerIssuesState {
        return this._state;
    }

    private _pageContext: IVssPageContext;
    private _state: ITriggerIssuesState;
    private definitionId: number;
}